import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-tags',
  templateUrl: './customer-tags.component.html',
  styleUrls: ['./customer-tags.component.scss']
})
export class CustomerTypesComponent implements OnInit {

  /*public data: CustomerType[] = [];

  @ViewChild('modal') modal!: ModalDialogComponent;
  @ViewChild('deleteModal') deleteModal!: ModalDialogComponent;

  search: string = "";
  selectedTag: CustomerType = new CustomerType();

  public actions: DottedDropdownAction[] = [];

  showDeleteModal(context: CustomerType) {
    this.selectedTag = { ...context };
    this.deleteModal.show();
  }

  showAddModal() {
    this.selectedTag = new CustomerType();
    this.modal.show();
  }

  clearSearch() {
    this.search = "";
  }

  editTag(context: CustomerType): void {
    this.selectedTag = { ...context };
    this.modal.show();
  }

  modalClosed(ok: boolean): void {
    if (ok == false) {
      return;
    }

    if (this.selectedTag.value == null || this.selectedTag.value.trim() === '') {
      this.data.push({ ...this.selectedTag });
    } else {
      const existing = this.data.find(i => i.value == this.selectedTag.value);
      existing!.description_en = this.selectedTag.description_en;
      existing!.description_el = this.selectedTag.description_el;
      existing!.description_hr = this.selectedTag.description_hr ?? this.selectedTag.description_en;
      existing!.description_sr = this.selectedTag.description_sr ?? this.selectedTag.description_en;
      existing!.color = this.selectedTag.color;
    }
  }

  deleteModalClosed(ok: boolean) {
    if (ok == false) {
      return;
    }

    const existing = this.data.findIndex(i => i.value == this.selectedTag.value);
    this.data.splice(existing, 1);
  }*/

  constructor() { }

  ngOnInit(): void {
    //this.loadActions();
  }

  /*loadActions = async () => {
    const justToLoadTranslations = await firstValueFrom(this.translate.get('report.status.completed'));
    this.actions = [
      { name: this.translate.instant('common.buttons.edit'), color: 'default', action: (context: CustomerType) => this.editTag(context) },
      { name: this.translate.instant('common.buttons.delete'), color: 'danger', action: (context: CustomerType) => this.showDeleteModal(context) }
    ];
  }*/

}
